import { lazy, Suspense } from 'react';
import { AuthGuard } from '@emfood/shared';
import { Outlet, createRoute, SearchSchemaInput } from '@tanstack/react-router';

import { paths } from 'src/routes/paths'; // TODO

import DashboardLayout from 'src/layouts/dashboard';

import { SplashScreen, LoadingScreen } from 'src/components/loading-screen';

import { StoriesSearchParamsSchema } from 'src/sections/stories/view';

import { rootRoute } from './root';

const StoriesList = lazy(() => import('src/sections/stories/view'));

// News routes
const storiesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'stories',
  component: () => (
    <AuthGuard
      splashScreen={<SplashScreen />}
      loginPath={paths.auth.jwt.login}
      pathOnAuthProblem={paths.auth.jwt.login}
    >
      <DashboardLayout>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </DashboardLayout>
    </AuthGuard>
  ),
});

const storiesListRoute = createRoute({
  getParentRoute: () => storiesRoute,
  path: '/',
  validateSearch: (search: unknown & SearchSchemaInput) =>
    StoriesSearchParamsSchema.validateSync(search),
  component: StoriesList,
});

export const storiesRouteTree = storiesRoute.addChildren([storiesListRoute]);
